import type { ReactNode } from "react";
import { twJoin } from "tailwind-merge";

import { Menu01Icon } from "@/components/Icons/Menu01Icon";
import { cardSurfaceVariants } from "@/design-system/Card";
import { Inline } from "@/design-system/Inline";
import { Spread } from "@/design-system/Spread";
import { DragOverlay } from "@/ui-adapters/DndKit";

interface Props {
  show: boolean;
  title?: string;
  children: ReactNode;
  headerActions?: ReactNode;
}
export function DynamicRepeaterItemOverlay({ show, title, children, headerActions }: Props): React.ReactNode {
  if (!show) {
    return null;
  }

  return (
    <DragOverlay>
      {show ? (
        <article
          className={twJoin(
            "flex flex-col gap-space-md p-space-md shadow-overlay ring-2 ring-border-brand",
            cardSurfaceVariants({ borderTone: "brand" }),
          )}
        >
          <Spread space="sm">
            {title && <span className="text-body-emphasis">{title}</span>}
            <Inline gap="md" align="center" wrap={false}>
              <span className="shrink-0 text-text-secondary">
                <Menu01Icon />
              </span>
              {headerActions}
            </Inline>
          </Spread>
          {children}
        </article>
      ) : null}
    </DragOverlay>
  );
}
